import React from "react";
import { PolarArea } from "react-chartjs-2";

const PolarAreaChart = ({ data, options }) => {
  return (
    <PolarArea
      data={data}
      options={{
        maintainAspectRatio: false,
        ...options,
      }}
    />
  );
};

export default PolarAreaChart;
